import groupBy from 'lodash/groupBy';
import Box from '@mui/material/Box';

import CustomBox from '../common/CustomBox';
import CustomSubheader from './CustomSubheader';
import ProviderCustomList from './ProviderCustomList';
import './Highlights.scss';

const Highlights = ({ provider }) => {
  const categories = groupBy(provider.highlights, i => i.title);
  if (!provider.highlights || !provider.highlights.length) return <></>;

  return (
    <CustomBox borderless className='Highlights'>
      <CustomSubheader>
        Highlights
      </CustomSubheader>
      <Box paddingTop='0.688rem'>
        {Object.keys(categories).map((k, i) =>
          <ProviderCustomList
            key={i}
            title={k.replace('_', ' ')}
            items={categories[k].map(issue => issue.description)}
            borderBottomList
          />
        )}
      </Box>
    </CustomBox>
  );
};

export default Highlights;
